import { DataGrid } from "@mui/x-data-grid";
import { useState, useEffect } from "react";
import LinearProgress from "@mui/material/LinearProgress";
import { Stack } from "@mui/material";

const TableGrid = ({
  rows,
  columns,
  pageSize,
  page,
  setPage,
  setPageSize,
  rowsPerPageOptions,
  fetchingFunction,
  paginationMode = "client",
  isFetching,
  totalCount,
  hidePagination,
  isProblematic,
  keepNonExistentRowsSelected = false,
  ...rest
}) => {
  const isPaginationMode = paginationMode === "server";
  const [_pageSize, _setPageSize] = useState(pageSize);

  useEffect(() => {
    isPaginationMode && fetchingFunction
      ? fetchingFunction(_pageSize, page)
      : "";
  }, [page, _pageSize]);

  return (
    <div style={{ width: "100%" }}>
      <DataGrid
        keepNonExistentRowsSelected={keepNonExistentRowsSelected}
        autoHeight
        pagination
        getCellClassName={(params) =>
          params.row.crosscheck_status === 2 ? "conditional-red-background" : ""
        }
        page={page}
        rowCount={
          totalCount
            ? Number(totalCount)
            : !rows.length
              ? 0
              : Number(rows[0].total_count)
        }
        disableColumnMenu
        loading={isFetching}
        onPageSizeChange={(newPageSize) => (
          _setPageSize(newPageSize), setPageSize ? setPageSize(newPageSize) : ""
        )}
        columns={columns}
        pageSize={_pageSize}
        rowsPerPageOptions={rowsPerPageOptions}
        {...rest}
        headerHeight={60}
        paginationMode={paginationMode}
        onPageChange={(newPage) => (isPaginationMode ? setPage(newPage) : "")}
        rows={rows.length === 0 ? [] : rows}
        components={{
          LoadingOverlay: LinearProgress,
          NoRowsOverlay: () => (
            <Stack height="100%" alignItems="center" justifyContent="center">
              Δεν υπάρχουν εγγραφές
            </Stack>
          ),
        }}
        sx={{
          "& .MuiDataGrid-columnHeaderTitle": {
            textOverflow: "clip",
            whiteSpace: "break-spaces",
            lineHeight: 1,
          },
          "& .MuiDataGrid-columnHeader: focus": {
            outline: "none",
          },
          "& .MuiDataGrid-cell": {
            textOverflow: "clip",
            whiteSpace: "break-spaces",
            lineHeight: 1,
          },
          "& .MuiDataGrid-row": {
            backgroundColor: isProblematic ? "#c0000041" : "white",
          },
          "& .MuiDataGrid-footerContainer": {
            display: hidePagination ? "none" : "block",
          },
        }}
      />
    </div>
  );
};

export default TableGrid;
